import { IEqualityComparer, PropertyComparisonService } from "../../properties/common/propertyComparison.js";


function isObject(obj: any): obj is Record<string, any> {
    return obj !== null && typeof obj === "object";
}


type ColorLike = { r: number; g: number; b: number; a?: number };
const ColorComparer = new class implements IEqualityComparer {

    canCompare(x: unknown, y: unknown): boolean {
        if (!isObject(x) || !isObject(y)) return false;
        if ("r" in x && "g" in x && "b" in x && "r" in y && "g" in y && "b" in y) {
            return true;
        }
        return false;
    }

    areEqual(a: unknown, b: unknown): boolean {
        const colorA = a as ColorLike;
        const colorB = b as ColorLike;
        return colorA.r === colorB.r && colorA.g === colorB.g && colorA.b === colorB.b && (colorA.a ?? 1) === (colorB.a ?? 1);
    }
}
PropertyComparisonService.registerComparer(ColorComparer);


type VectorLike = { x: number; y: number; z?: number; w?: number };

const VectorComparer = new class implements IEqualityComparer {

    canCompare(x: unknown, y: unknown): boolean {
        if (!isObject(x) || !isObject(y)) return false;
        if ("x" in x && "y" in x && "x" in y && "y" in y) {
            return true;
        }
        return false;
    }

    areEqual(a: unknown, b: unknown): boolean {
        const vecA = a as VectorLike;
        const vecB = b as VectorLike;
        return vecA.x === vecB.x
            && vecA.y === vecB.y
            && (vecA.z ?? 0) === (vecB.z ?? 0)
            && (vecA.w ?? 0) === (vecB.w ?? 0);
    }
}
PropertyComparisonService.registerComparer(VectorComparer);